import React from 'react';
import { IconProps } from '.';

const SvgBoxKakaotalkShopping = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FBE104'
        d='M18.667 2H5.333A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2Z'
      />
      <path
        fill='#3C1E1E'
        d='M5.875 6h3.25v4c0 .828-.728 1.541-1.625 1.541S5.875 10.828 5.875 10V6ZM10.375 6h3.25v4c0 .828-.727 1.541-1.625 1.541s-1.625-.713-1.625-1.542V6ZM14.875 6h3.25v4c0 .828-.727 1.541-1.625 1.541s-1.625-.713-1.625-1.542V6Z'
      />
      <path
        fill='#3C1E1E'
        fillRule='evenodd'
        d='M6.5 12.594v5.655h11v-5.655c-.313.11-.65.17-1 .17-.896 0-1.7-.392-2.25-1.015A2.993 2.993 0 0 1 12 12.765c-.896 0-1.7-.393-2.25-1.016a2.993 2.993 0 0 1-3.25.845Zm8.125 3.905v-2h-.75v2h.75Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxKakaotalkShopping;
